import type { DialoguePool } from '@/state/types';

export const L01_DIALOGUE: DialoguePool = {
  slowPlay: [
    'Ten pages. Terms and conditions. Written in the 1970s, by someone upset.',
    'Read it. Don\u2019t read it. I\u2019ll know either way. I always know.',
    'The correct spelling of ACCEPT is on one of those buttons. Good luck, FEEB.',
  ],
  tokenLoss: [
    'ACCEPPT? You can\u2019t even spell your own submission to authority.',
    'AACCEPT. You stuttered. A token for your effort. A small one.',
    'ACCPT. Vowels were invented for a reason, FEEB. That reason is dignity.',
  ],
  solution: [
    'Accepted. You read the unreadable. Or pretended to. Close enough.',
    'ACCEPT. Spelled correctly. I\u2019m almost impressed.',
    'Contract signed. Your rights have been relocated. Column V.',
  ],
  spite: ['ACCEPT. Again. The agreement renews itself. I drafted it that way.'],
};
